module.exports = __webpack_public_path__ + "static/img/class_23.29811ac8.jpg";